import { useEffect, useRef } from "react";
import { resetElementHeight } from "./helpers";

function useDynamicTextAreaHeight(readOnly, value) {
  const textareaRef = useRef(null);
  const textContainerRef = useRef(null);

  const adjustHeight = () => {
    const textarea = textareaRef.current;
    const container = textContainerRef.current;

    if (textarea && container) {
      textarea.style.height = '0px';
      
      const nextHeight = textarea.scrollHeight;

      textarea.style.height = `${nextHeight}px`;
      container.style.minHeight = `${nextHeight + 5}px`;
    }
  };

  useEffect(() => {
    if (!readOnly) {
      adjustHeight();
    } else if (textContainerRef.current) {
      textContainerRef.current.style.minHeight = 'auto';
    }
  }, [value, readOnly]);

  return [textContainerRef, textareaRef];
}
 
export { useDynamicTextAreaHeight }